/**
 * Mobile Menu Debug Script
 * Temporary debugging to identify mobile menu issues
 */

(function() {
  'use strict';

  console.log('=== MM MOBILE MENU DEBUG ===');

  // Wait for DOM to be ready
  function checkElements() {
    const toggle = document.querySelector('.mm-header__mobile-toggle');
    const menu = document.querySelector('.mm-mobile-menu');
    const nav = document.querySelector('.mm-mobile-menu__nav');
    const overlay = document.querySelector('.mm-mobile-menu__overlay');
    const closeBtn = document.querySelector('.mm-mobile-menu__close');

    console.log('Toggle button:', toggle);
    console.log('Menu container:', menu);
    console.log('Nav element:', nav);
    console.log('Overlay:', overlay);
    console.log('Close button:', closeBtn);

    if (menu) {
      const styles = window.getComputedStyle(menu);
      console.log('Menu computed styles:', {
        position: styles.position,
        display: styles.display,
        opacity: styles.opacity,
        visibility: styles.visibility,
        zIndex: styles.zIndex,
        width: styles.width,
        height: styles.height,
        top: styles.top,
        left: styles.left
      });

      console.log('Menu classes:', menu.className);
      console.log('Menu HTML:', menu.innerHTML.substring(0, 200));
    }

    if (toggle) {
      console.log('Toggle aria-expanded:', toggle.getAttribute('aria-expanded'));

      // Add manual test function
      toggle.addEventListener('click', function() {
        console.log('=== TOGGLE CLICKED ===');
        console.log('Menu classes after click:', menu ? menu.className : 'NO MENU');
        console.log('Body overflow:', document.body.style.overflow);

        if (menu) {
          const stylesAfter = window.getComputedStyle(menu);
          console.log('Menu styles after click:', {
            opacity: stylesAfter.opacity,
            visibility: stylesAfter.visibility,
            pointerEvents: stylesAfter.pointerEvents
          });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkElements);
  } else {
    checkElements();
  }

  // Check again after a delay
  setTimeout(checkElements, 1000);

  console.log('=== END DEBUG ===');
})();
